
import Http from "../helpers/Http";

class ClientDataService {
  getAll(type) {
    let endpoint = "/customers";
    if(type != null) { 
      endpoint = "/customers?type=" + type; 
    }
    return Http.get(endpoint);
  }

  getCustomer(id) {
    return Http.get(`/customers/${id}`);
  }

  getCustomerWithPacks(id){
    return Http.get(`/customers/${id}?pkgs=S&cb=S`);
  }

  create(data) {
    return Http.post("/customers",data);
  }

  update(data) {
    return Http.update("/customers",data);
  }
  
  getLocationAddress() {
    return Http.get("/pct");
  }

  updateAddress(data) {
    return Http.update("/address",data);
  }

  getCustomersStats(){
    return Http.get("/customers/stats/totals");
  }

  getLocationsDelivery(){
    return Http.get("/customersdv");
  }

  updateCustomerRate(data) {
    return Http.update("/customers/change/rate",data);
  }
  updateCutomerAddress(data){
    return Http.update("/address",data);
  }

  getCustomerTypes() {
    return Http.get("/customersTypes");
  } 
  
  newCustomerType(data) {
    return Http.post("/customersTypes",data);
  }

  updateCustomerType(data) {
    return Http.update("/customersTypes",data);
  }

  addContact(data){
    return Http.post('/customers/contacts', data)
  }

  updateContact(data){
    return Http.update('/customers/contacts', data)
  }

  deleteContact(data){
    return Http.update('/customers/contacts/inactivate', data)
  }
  

}

export default new ClientDataService();